<template>
    <div>
        <div class="search-container primary mb10 mt10">
            <div class="form-box">
                <input class="input-field" v-model="name" placeholder="请输入公司名称"/>
                <button class="search-btn" @click="toGetServicerComList()"><i class="icon iconfont icon-search"></i></button>
            </div>
        </div>
        <div class="column-layout">
            <div v-if="checkBox" class="table-layout">
                <el-table ref="mkuList" :data="servicerComList" border style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column v-if="checkBox" :selectable="selectable" type="selection" width="55"></el-table-column>
                    <el-table-column prop="name" label="机构名称" width="180px" align="left"></el-table-column>
                    <el-table-column prop="level" label="机构级别" width="80px" align="center"></el-table-column>
                    <el-table-column prop="svcDispLevel" label="服务调度级别" width="100px" align="center"></el-table-column>
                    <el-table-column prop="regionName" label="所在地区" width="200px" align="left"></el-table-column>
                    <el-table-column prop="contactName" label="联系人" width="180px" align="left"></el-table-column>
                    <el-table-column prop="contactTel" label="联系电话" width="110px" align="center"></el-table-column>
                    <el-table-column prop="contactEmail" label="联系电子邮箱" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="table-layout" v-else>
                <el-table :data="servicerComList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column width="55">

                        <template slot-scope="rows">
                            <div class="copy-radio ml15" :class="{'circle' : checlServicerCom!= null && checlServicerCom.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="机构名称" width="180px" align="left"></el-table-column>
                    <el-table-column prop="level" label="机构级别" width="80px" align="center"></el-table-column>
                    <el-table-column prop="svcDispLevel" label="服务调度级别" width="100px" align="center"></el-table-column>
                    <el-table-column prop="regionName" label="所在地区" width="200px" align="left"></el-table-column>
                    <el-table-column prop="contactName" label="联系人" width="180px" align="left"></el-table-column>
                    <el-table-column prop="contactTel" label="联系电话" width="110px" align="center"></el-table-column>
                    <el-table-column prop="contactEmail" label="联系电子邮箱" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'

    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-servicer-com-for-select',
        desc: '选择服务公司',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            servicerComIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                servicerComList: [],
                selectServicerComList: [],
                checlServicerCom: null,
                name: null
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.toGetServicerComList();
        },
        methods: {
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.toGetServicerComList();
            },
            toGetServicerComList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = self.filter || {};
                if(!Utils.isNoB(self.name)) {
                    filterItems.name = self.name;
                }
                filterItems.closed = false;
                postData.filterItems = filterItems;
                servicerApi.getServicerComListByContext(postData, function (result) {
                    if(result.type == "info") {
                        self.servicerComList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectable: function (row, index) {
                let selectIds = this.servicerComIds;
                if(selectIds.indexOf(row.id) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            handleSelectionChange: function (val) {
                this.selectServicerComList = val;
            },
            handleCurrentChange: function (val) {
                this.checlServicerCom = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let servicerComList = self.selectServicerComList;
                    if(servicerComList != null && servicerComList.length > 0) {
                        result.type = "info";
                        result.data = servicerComList;
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个服务公司！';
                    }
                } else {
                    let servicerCom = self.checlServicerCom;
                    if(servicerCom != null) {
                        result.type = "info";
                        result.data = servicerCom;
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个服务公司！';
                    }
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/ServicerComForSelect.vue